import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import CustomLink from "@gc-npm/components.custom-link";
import C2CModule from "@/components/Modals/C2CModule";
import TextInfo, {
  TEXT_KIND,
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_ALIGN,
  TEXT_FONT_WEIGHT,
  TEXT_DECORATION,
} from "@gc-npm/components.text";
import Glyph from "@gc-npm/components.icon-glyph";
import { COLORS } from '@gc-npm/utils.enums.colors';

const ShoppingCart900 = ({button, origin, phone, campaign}) => {
  const screenType = useSelector((state) => state.UI.screenType);
  const [show900, setShow900] = useState(null);
  const textos = {
    callText: "Llama gratis al",
    callNumber: "900 106 260",
    c2cText: "te llamamos.",
    callHours: "Horario atención 9 a 22 h.",
  };
  useEffect(() => {
    // Función para actualizar el estado cuando window.va.show900 cambia
    const handleShow900Change = () => {
      const updatedShow900 = window.va && window.va.show900;
      if (updatedShow900 !== undefined) {
        setShow900(updatedShow900);
      }
    };

    // Llama a la función de manejo cuando el componente se monta
    handleShow900Change();

    // Agrega un listener para futuros cambios en window.va.show900
    window.addEventListener("va.show900", handleShow900Change);

    // Limpia el listener cuando el componente se desmonta
    return () => {
      window.removeEventListener("va.show900", handleShow900Change);
    };
  }, []);
  return (
    <>
      {!button && show900 && (
        <div className={`ShoppingCart_call ${origin ? origin : ''}`}>
          <TextInfo
            text={textos.callText}
            color={TEXT_COLOR.GREY5}
            size={TEXT_SIZE.BODY1}
            fontType={TEXT_FONT_WEIGHT.REGULAR}
            align={TEXT_ALIGN.LEFT}
            kind={TEXT_KIND.PARAGRAPH}
          />
          <CustomLink
            taggingInfo={{
              componentName: "900 pack",
              componentContent: "Teléfono",
            }}
            href={`tel:+34${phone || textos.callNumber}`}
            className="SCX-telefono-href"
          >
            <TextInfo
              text={phone || textos.callNumber}
              kind={TEXT_KIND.PARAGRAPH}
              color={origin === 'productosRecomendados' ? TEXT_COLOR.MOVISTAR_BLUE : TEXT_COLOR.GREY5}
              size={TEXT_SIZE.BODY1}
              fontType={TEXT_FONT_WEIGHT.BOLD}
              align={TEXT_ALIGN.LEFT}
            />
          </CustomLink>
          {textos.c2cText && (
            <div className="ShoppingCart_call-c2c">
              <TextInfo
                text="o"
                color={TEXT_COLOR.GREY5}
                size={TEXT_SIZE.BODY1}
                fontType={TEXT_FONT_WEIGHT.REGULAR}
                kind={TEXT_KIND.PARAGRAPH}
              />
              <C2CModule
                text={textos.c2cText}
                color={TEXT_COLOR.GREY6}
                size={TEXT_SIZE.BODY1}
                fontType={TEXT_FONT_WEIGHT.REGULAR}
                kind={TEXT_KIND.PARAGRAPH}
                decoration={TEXT_DECORATION.UNDERLINE}
                phone={phone}
                campaign={campaign}
              />
            </div>
          )}
          <TextInfo
            text={textos.callHours}
            color={TEXT_COLOR.GREY5}
            size={TEXT_SIZE.BODY1}
            fontType={TEXT_FONT_WEIGHT.REGULAR}
            align={TEXT_ALIGN.LEFT}
            kind={TEXT_KIND.PARAGRAPH}
          />
        </div>
      )}{" "}
      {button && show900 && (
        <CustomLink
            ariaLabel="teléfono"
            taggingInfo={{
              componentName: "900 pack",
              componentContent: "Teléfono",
            }}
            href={`tel:+34${phone || textos.callNumber}`}
          >
            <div className="ShoppingCart_call--mobile">
            <Glyph
              id="telefono"
              height={22}
              width={22}
              color={TEXT_COLOR.MOVISTAR_BLUE}
            />
        </div>
          </CustomLink>
      )}
      <style jsx>
        {`
          .ShoppingCart_call {
            padding-top: 1rem;
            display: flex;
            -webkit-box-align: center;
            align-items: center;
            gap: 0.2rem;
            flex-wrap: wrap;
            &.productosRecomendados{
              padding-top: 0;
            }
          }
          
          .ShoppingCart_call-c2c {
            display: flex;
            gap: 0.2rem;
          }
          .ShoppingCart_call--mobile {
            width: 48px !important;
            height: 48px;
            background: ${COLORS.movistarWhite};
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        `}
      </style>
    </>
  );
};

export default ShoppingCart900;
